import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from './button';

export function StartOverButton({
  label,
  onClick,
  className,
}: {
  label?: string;
  className?: string;
  onClick?: () => void;
}) {
  const navigate = useNavigate();
  return (
    <Button
      color="primary"
      size="lg"
      onClick={() => {
        navigate('/request');
        if (onClick) {
          onClick();
        }
      }}
      className={className}
    >
      {label || 'Start Over'}
    </Button>
  );
}
